import { format, startOfYesterday, subWeeks } from 'date-fns';

export const CHANGE_FILTER_DATE_END = 'stats/reports/schedules/CHANGE_FILTER_DATE_END';
export const changeFilterDateEnd = endDate => ({ type: CHANGE_FILTER_DATE_END, endDate });

export const CHANGE_FILTER_DATE_START = 'stats/reports/schedules/CHANGE_FILTER_DATE_START';
export const changeFilterDateStart = startDate => ({ type: CHANGE_FILTER_DATE_START, startDate });

export const CHANGE_FILTER_VENUE = 'stats/reports/schedules/CHANGE_FILTER_VENUE';
export const changeFilterVenue = selectedVenues => ({ type: CHANGE_FILTER_VENUE, selectedVenues });

export const CHANGE_FILTER_CLASS = 'stats/reports/schedules/CHANGE_FILTER_CLASS';
export const changeFilterClass = selectedClasses => ({ type: CHANGE_FILTER_CLASS, selectedClasses });

export const CHANGE_FILTER_START_TIME = 'stats/reports/schedules/CHANGE_FILTER_START_TIME';
export const changeFilterStartTime = selectedStartTimes => ({ type: CHANGE_FILTER_START_TIME, selectedStartTimes });

export const CHANGE_PAGE = 'stats/reports/schedules/CHANGE_PAGE';
export const changePage = page => ({ type: CHANGE_PAGE, page });

export const TOGGLE_SORT_DIRECTION = 'stats/reports/schedules/TOGGLE_SORT_DIRECTION';
export const toggleSortDirection = () => ({ type: TOGGLE_SORT_DIRECTION });

export const RESET_PAGE = 'stats/reports/schedules/RESET_PAGE';
export const resetPage = () => ({ type: RESET_PAGE });

export const SET_FIELDS_ENTRY = 'stats/reports/schedules/SET_FIELDS_ENTRY';
export const setFieldsEntry = venues => ({
  type: SET_FIELDS_ENTRY,
  selectedVenues: venues,
});

export const SET_FIELDS = 'stats/reports/schedules/SET_FIELDS';
export const setFields = (newClasses, newStartTimes) => ({
  type: SET_FIELDS,
  newClasses,
  newStartTimes,
});

export const initialState = {
  endDate: format(startOfYesterday(), 'yyyy-MM-dd'),
  startDate: format(subWeeks(startOfYesterday(), 4), 'yyyy-MM-dd'),
  possibleClasses: [],
  possibleStartTimes: [],
  selectedClasses: [],
  selectedStartTimes: [],
  selectedVenues: [],
  page: 1,
  sortDirection: 'dsc',
  hasBeenVisited: false,
};

export default (state = initialState, action) => {
  const {
    type,
    endDate,
    startDate,
    newClasses,
    newStartTimes,
    selectedClasses,
    selectedVenues,
    selectedStartTimes,
    page,
  } = action;

  switch (type) {
    case CHANGE_FILTER_CLASS:
      return { ...state, selectedClasses };
    case CHANGE_FILTER_DATE_END:
      return { ...state, endDate };
    case CHANGE_FILTER_DATE_START:
      return { ...state, startDate };
    case CHANGE_FILTER_VENUE:
      return { ...state, selectedVenues };
    case CHANGE_FILTER_START_TIME:
      return { ...state, selectedStartTimes };
    case CHANGE_PAGE:
      return { ...state, page };
    case TOGGLE_SORT_DIRECTION:
      return { ...state, sortDirection: state.sortDirection === 'dsc' ? 'asc' : 'dsc' };

    case RESET_PAGE:
      return { ...state, page: 1 };
    case SET_FIELDS_ENTRY:
      return { ...state, selectedVenues, hasBeenVisited: true };
    case SET_FIELDS: {
      // reconcile selected classes/start times; we want to select everything that comes back from the endpoint EXCEPT items we've already unselected
      const selectedClassesSet = new Set(state.selectedClasses);
      const selectedStartTimesSet = new Set(state.selectedStartTimes);
      const unselectedClassesSet = new Set(
        state.possibleClasses.filter(possibleClass => !selectedClassesSet.has(possibleClass))
      );
      const unselectedStartTimesSet = new Set(
        state.possibleStartTimes.filter(possibleStartTime => !selectedStartTimesSet.has(possibleStartTime))
      );
      return {
        ...state,
        possibleClasses: newClasses,
        possibleStartTimes: newStartTimes,
        selectedClasses: newClasses.filter(possibleClass => !unselectedClassesSet.has(possibleClass)),
        selectedStartTimes: newStartTimes.filter(possibleStartTime => !unselectedStartTimesSet.has(possibleStartTime)),
      };
    }
    default:
      return state;
  }
};
